import { render, staticRenderFns } from "./naj-social-identity-input.vue?vue&type=template&id=ce25fa0a&scoped=true&"
import script from "./naj-social-identity-input.vue?vue&type=script&lang=js&"
export * from "./naj-social-identity-input.vue?vue&type=script&lang=js&"
import style0 from "./naj-social-identity-input.vue?vue&type=style&index=0&id=ce25fa0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce25fa0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
